// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"5512":"b80eb6be","8688":"c979e12a","9312":"cc603fce"}[chunkId] + ".chunk.css";
};